<template>
    <div>
        <div id="cnCdStock" style="width: 100%;height:calc(100vh - 84px);overflow-x: auto;">
            <div style="display: flex; width: 100%; justify-content: space-between; flex-wrap: nowrap;background-color: #fff;">
                <vxe-form v-bind="formOptions" style="flex-wrap: wrap;overflow-x: hidden;  " size="mini">
                </vxe-form>
                <vxe-toolbar ref="toolbarRef" custom>
                </vxe-toolbar>
            </div>
            <vxe-table id="driverInfo" :data="tableData" border :column-config="{ resizable: true }" class="table-style"
                :columns="columns" stripe width="100%" height="auto" :custom-config="customConfig" ref="tableRef"
                :row-config="{ isCurrent: true /* 启用当前行高亮 */  }">
                <vxe-column type="seq" width="50" align="center"></vxe-column>
                <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"
                    align="center" :filters="column.field === 'status' ? statusFilters : (column.field === 'activeTaskNum'?activeTaskNumFilters:null)">
                    <template #default="{ row, column }">
                        <vxe-tag v-if="column.field === 'status'" :status="row[column.field]?'success':'error'"> {{ row[column.field] ? '在职' : '离职' }} </vxe-tag>
                        <vxe-tag v-else-if="column.field === 'activeTaskNum'" :status="row[column.field]?'success':'warning'"> {{ row[column.field] ? '运输中' : '空闲中' }} </vxe-tag>
                        <!-- <vxe-switch v-if="column.field === 'status'" v-model="row.status"
                            @change="handleSwitchChange(row)">
                        </vxe-switch> -->
                        <span v-else> {{ row[column.field] }} </span>
                    </template>
                </vxe-column>
                <vxe-column title="操作" width="250" >
                    <template #default="{ row }">
                        <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                            @click="editEvent(row)">编辑</vxe-button>
                        <vxe-button mode="text" status="primary" icon="vxe-icon-send"
                            @click="historicalLocation(row)">历史位置</vxe-button>
                        <vxe-button mode="text" status="warning" icon="vxe-icon-indicator" v-if="row.activeTaskNum"
                            @click="release(row)">释放</vxe-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <vxe-modal resize destroy-on-close show-footer show-confirm-button show-cancel-button
                v-model="showEditPopup" :title="selectRow ? '编辑' : '新增'" width="70vw" height="45vh" :loading="loading"
                :confirm-closable="false" @confirm="confirmEvent" @cancel="cancelEvent" @close="cancelEvent">
                <vxe-form ref="formRefDriver" class="form-style" v-bind="formOptionsAdd">
                </vxe-form>
                <!-- <div class="status-box" v-if="formOptionsAdd.data.status">
                    <vxe-button status="error" content="离职" @click="changeStatus(formOptionsAdd.data)"></vxe-button>
                </div> -->
            </vxe-modal>
        </div>
        <!-- 司机历史位置弹窗 -->
        <el-dialog v-dialogDrag :title="locationSeacher.driverName + ' - ' + '历史位置'" :visible.sync="locationShow" width="50%" :before-close="locationClose">
            <div class="location_top">
                <el-date-picker size="mini" v-model="locationData" type="daterange" value-format="yyyy-MM-dd" range-separator="至" 
                start-placeholder="开始日期" end-placeholder="结束日期" @change="getLocationTime"> </el-date-picker>
                <el-button style="margin-left: 20px;" size="mini" type="primary" plain @click="getLocation">搜索</el-button>
            </div>
            <div  class="location_list" v-if="locationList.length > 0">
                <el-timeline >
                    <el-timeline-item v-for="(location, index) in locationList" :key="index" :timestamp="location.requestTime">
                        {{location.streetDesc}} - {{ location.locationDesc }}
                    </el-timeline-item>
                </el-timeline>
            </div>
            <div v-else>
                <el-divider>暂无历史位置</el-divider>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { VxeUI } from 'vxe-pc-ui'
import XEUtils from 'xe-utils'
// 表格自适应
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'driverInfo',
    mixins: [userProfile],
    //组件创建
    created() {
        this.loadTableData();
    },
    data() {
         const statusOptions = {
            name: 'VxeRadioGroup',
            props: {
                type: 'button'
            },
            options: [
                { label: '在职', value: true,disabled: true },
                { label: '离职', value: false },
            ],
            events: {
                change: ({ data, event }) => {
                    this.changeStatus(data)
                }
            }
        }
        const formOptionsAdd = {
            titleWidth: 50,
            titleAlign: 'right',
            titleColon: true,
            data: {
                id: '',
                driverName: '',
                phone: '',
                idNum: '',
                status:true,
            },
            rules: {
                driverName: [
                    { required: true, message: '请输入司机姓名' },
                ],
                phone: [
                    { required: true, message: '请输入电话号码' }
                ],
                idNum: [
                    { required: true, message: '请输入身份证号' }
                ]
            },
            items: [
                { field: 'driverName', title: '司机姓名', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'phone', title: '电话号码', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'idNum', title: '身份证号', span: 24, itemRender: { name: 'VxeInput' } },
                { field: 'status', title: '人员状态', span: 24,  itemRender: statusOptions  },
            ]
        }
        const formOptions = {
            data: {
                driverName: '',
            },
            items: [
                { field: 'driverName', title: '司机姓名查询', span: 13, itemRender: { name: 'VxeInput' } },
                // { field: 'endTime', title: '结束时间', span: 6, itemRender: { name: 'VxeDatePicker' } },
                {
                    span: 3,
                    // collapseNode: true,
                    align: 'center',
                    itemRender: {
                        name: 'VxeButtonGroup',
                        options: [
                            { type: 'submit', content: '搜索', status: 'primary', name: 'search', style: 'min-width: 80px' },
                            { type: 'reset', content: '重置', name: 'reset', style: 'min-width: 80px' },
                            { type: 'submit', content: '添加司机信息', status: 'success', name: 'obtainInventory', style: 'min-width: 80px' },
                        ],
                        events: {
                            click: this.handleButtonClick // 调用 methods 中的方法
                        }
                    }
                }
            ]
        }
        return {
            tableData: [],
            columns: [],
            formOptions,
            formOptionsAdd,
            showEditPopup: false,
            loading: false,
            selectRow: undefined,
            isAddEdit: null,
            locationShow: false, // 查看司机历史位置弹窗
            locationData:[], // 搜索位置时间
            locationSeacher:{
                startTime:'',
                endTime:'',
                driverName:'',
            },
            locationList:[],// 历史位置列表
            statusFilters:[
                {
                    label: '在职', value: true
                },
                {
                    label: '离职', value: false
                }
            ],
            activeTaskNumFilters:[
                {
                    label: '运输中', value: 1
                },
                {
                    label: '空闲中', value: 0
                }
            ],
        }
    },
    mounted() { 
    },
    methods: {
        // 查看司机历史位置
        historicalLocation(data){
            this.locationSeacher.driverName = data.driverName
            // 弹出窗口
            this.locationShow = true
        },
        // 获取时间
        getLocationTime(data){
            if(data === null){
                this.locationSeacher.startTime = ''
                this.locationSeacher.endTime = ''
            }else{
                this.locationSeacher.startTime = data[0]
                this.locationSeacher.endTime = data[1]
            }
        },
        // 关闭历史位置弹窗
        locationClose(){
            this.locationShow = false
            this.locationSeacher.startTime = ''
            this.locationSeacher.endTime = ''
            this.locationData = []
            this.locationList = []
        },
        // 查询位置
        getLocation(){
            if(this.locationSeacher.startTime === '' || this.locationSeacher.endTime === ''){
                this.$message.error('请选择时间范围');
            }else{
                this.$api.getLocations( { driverName: this.locationSeacher.driverName}, this.locationSeacher.startTime, this.locationSeacher.endTime )
                .then(res =>{
                    this.locationList = res
                })
        }
        },
        changeStatus(data){
            if(data.status === false){
                // 离职
                this.$confirm('是否要将此司机设置为离职？如果确认，那么此司机将立刻无法接单并自动退出接单小程序。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.changeDriverStatus( data.id ).then(res =>{
                        this.$message({
                            type: "success",
                            message: res
                        });
                    })
                }).catch(() => {
                    this.formOptionsAdd.data.status = true
                    return  false;         
                });
            }else{
                return  false;         
            }
        },
        handleButtonClick(options, button) {
            switch (button.name) {
                case 'search':
                    this.loadTableData();
                    break;
                case 'reset':
                    this.resetEvent();
                    break;
                case 'obtainInventory':
                    this.obtainInventory();
                    break;
            }
        },
        obtainInventory() {
            //判断新增
            this.isAddEdit = 1;
            this.showEditPopup = true;
            this.selectRow = undefined; 
            this.formOptionsAdd.data.status = true;
        },
        editEvent(row) {
            this.isAddEdit = 2;
            this.showEditPopup = true;
            this.selectRow = row;
            this.formOptionsAdd.data = XEUtils.clone(row, true)
        },
        cancelEvent() {
            this.showEditPopup = false;
            this.formOptionsAdd.data.driverName = '';
            this.formOptionsAdd.data.phone = '';
            this.formOptionsAdd.data.idNum = '';
            this.formOptionsAdd.data.id = '';
            this.loadTableData()
        },
        async confirmEvent() {         
            const $form = this.$refs.formRefDriver
            if ($form) {
                const errMap = await $form.validate()
                if (!errMap) {
                    this.showEditPopup = false
                    if (this.isAddEdit == 1) {
                        //   新增
                        delete this.formOptionsAdd.data.id;                    
                    } 
                    this.$api.insOrUpdateDriver( this.formOptionsAdd.data ).then(res =>{
                        VxeUI.modal.message({ content: this.isAddEdit === 1 ?'新增成功':'编辑成功', status: 'success' })
                        this.cancelEvent();
                        this.loadTableData();
                    })
                }
            }
        },
        // 重置
        resetEvent() {
            this.formOptions.data.driverName = '';
        },
        // 加载表格数据和列配置
        loadTableData() {
            this.$api.getDriverByName( {driverName: this.formOptions.data.driverName} ).then(res =>{
                this.columns = res.columns; // 动态列配置
                this.tableData = res.tableData; // 表格数据
            })
        },
        // 释放，将状态置为空闲
        release(data){
            this.$confirm('是否要释放此司机？如果确认，那么此司机将进入空闲状态。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.changeWorkStatus( data.id ).then(res =>{
                    this.loadTableData()
                    this.$message({
                        type: "success",
                        message: '已置为空闲'
                    })
                })
            })
        },
    }
}
</script>

<style lang="css" scoped>
.location_list{
    height: 400px;
    overflow: auto;
    margin: 20px;
}
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .form-style .vxe-form--item-title {
    width: 120px !important;
}

::v-deep .vxe-button {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 60px;
    /* padding:0 2px !important; */
}

::v-deep .vxe-form--wrapper {
    flex: 1;
    width: 100%;
    flex-wrap: wrap !important;

}
.status-box{
    margin-left: 40px;
}
</style>